export default __webpack_public_path__ + "static/media/uxcx-engagement.a25049dd.svg";